import { calculateZoomInRange } from './zoom';
import {
  BUBBLE_LINE_WIDTH,
  BUBBLE_RADIUS,
  FORKLIFT_SIZE,
  HIGHWAY_ARROW_SIZE,
  JIT_POINT_SIZE,
  MAX_BUBBLE_RADIUS,
  MIN_BUBBLE_RADIUS,
  RACK_SIZE,
} from '../constants/elements';

export const calcBubbleElementScales = (zoom: number) => {
  const radius = calculateZoomInRange(zoom, 0, 200, BUBBLE_RADIUS, BUBBLE_RADIUS * 4);
  const strokeWidth = calculateZoomInRange(zoom, 0, 200, BUBBLE_LINE_WIDTH, BUBBLE_LINE_WIDTH * 4);

  return {
    radius,
    dividerStrokeWidth: strokeWidth,
    arrowStrokeWidth: strokeWidth * 2,
  };
};

export const calcHighwayArrowScale = (zoom: number) => {
  const scale = calculateZoomInRange(zoom, 0, 200, HIGHWAY_ARROW_SIZE, HIGHWAY_ARROW_SIZE * 6);

  return scale;
};

export const calcForkliftScale = (zoom: number) => {
  const scale = calculateZoomInRange(zoom, 0, 200, FORKLIFT_SIZE, 2000);

  return scale;
};

export const calcRackScale = (zoom: number) => {
  const scale = calculateZoomInRange(zoom, 0, 200, RACK_SIZE, 2000);

  return scale;
};

export const calcJitPointSize = (zoom: number) =>
  calculateZoomInRange(zoom, 0, 200, JIT_POINT_SIZE, JIT_POINT_SIZE * 6);

export const getBubbleRadius = (scale: number): number =>
  Math.max(Math.min(10 / scale, MAX_BUBBLE_RADIUS), MIN_BUBBLE_RADIUS);
